/* eslint-disable import/extensions */
import React from 'react';
import { render } from 'react-dom';
import App from './containers/App/App.jsx';

render(<App />, document.getElementById('root'));
